import React from 'react';
import PropTypes from 'prop-types';
import { CTA_DEFAULT_MIN_WIDTH } from '@ui/button';
import { CtaButton } from '@web/molecules';
import { StyledCTAGroupComponent, CTAButtonWrapper } from './styles.js';

export const CTAGroup = ({
  ctas = [],
  buttonsPerRow = 2,
  buttonsPerRowMobile = 1,
  gap = 4,
}) => {
  return (
    <StyledCTAGroupComponent
      $buttonsPerRow={buttonsPerRow}
      $buttonsPerRowMobile={buttonsPerRowMobile}
      $gap={gap}
    >
      {ctas.map((cta, index) => {
        const ctaMinWidth = cta.minWidth ?? CTA_DEFAULT_MIN_WIDTH;

        return (
          <CTAButtonWrapper
            key={`${cta.href}-${cta.headerText ?? ''}-${cta.variant ?? index}`}
            $buttonsPerRow={buttonsPerRow}
            $buttonsPerRowMobile={buttonsPerRowMobile}
            $gap={gap}
            $minWidth={ctaMinWidth}
            $fullWidthMobile={cta.fullWidthMobile}
            $fullWidthDesktop={cta.fullWidthDesktop}
          >
            <CtaButton
              headerText={cta.headerText}
              variant={cta.variant}
              href={cta.href}
              alignment={cta.alignment}
              icon={cta.icon}
              iconAlignment={cta.iconAlignment}
              triggerModal={cta.triggerModal}
              modal={cta.modal}
              openNewTab={cta.openNewTab}
              minWidth={ctaMinWidth}
              fullWidthMobile={cta.fullWidthMobile}
              fullWidthDesktop={cta.fullWidthDesktop}
              sideMargin={cta.sideMargin}
            >
              {cta.children}
            </CtaButton>
          </CTAButtonWrapper>
        );
      })}
    </StyledCTAGroupComponent>
  );
};

CTAGroup.displayName = 'CTAGroup';

CTAGroup.propTypes = {
  ctas: PropTypes.arrayOf(
    PropTypes.shape({
      children: PropTypes.node.isRequired,
      href: PropTypes.string.isRequired,
      variant: PropTypes.string,
      ctaVariant: PropTypes.string,
      icon: PropTypes.string,
      iconAlignment: PropTypes.oneOf(['left', 'right']),
      headerText: PropTypes.string,
      alignment: PropTypes.oneOf(['left', 'center', 'right']),
      triggerModal: PropTypes.bool,
      modal: PropTypes.object,
      minWidth: PropTypes.number,
      fullWidthMobile: PropTypes.bool,
      fullWidthDesktop: PropTypes.bool,
      sideMargin: PropTypes.bool,
    }),
  ),
  buttonsPerRow: PropTypes.number,
  buttonsPerRowMobile: PropTypes.number,
  gap: PropTypes.number,
};
